import Vue from 'vue';

import { database } from '@/database';
import { shuffle } from './mixins/utilities';

export default {
  namespaced: true,
  state: {
    list: null,
    subscribed: false,
    observers: [],
  },
  mutations: {
    updateAll(state, games) {
      Vue.set(state, 'list', games);
    },
    subscribe(state) {
      Vue.set(state, 'subscribed', true);
    },
    addObserver(state, resolve) {
      Vue.set(state, 'observers', [
        ...state.observers,
        resolve,
      ]);
    },
    clearObservers(state) {
      Vue.set(state, 'observers', []);
    },
  },
  actions: {
    async create(
      arg1,
      game,
    ) {
      await database.ref(`games/${game.hash}`).set(game);
    },
    async join({ rootState }, { hash, players }) {
      const newPlayers = [...players, rootState.auth.uid];
      await database.ref(`games/${hash}/players`).set(newPlayers);
      // randomize player of first round
      await database.ref(`games/${hash}/rounds/0/player`).set(shuffle(newPlayers)[0]);
    },
    async start(arg1, { hash, players }) {
      await database.ref(`games/${hash}/requiredPlayers`).set(players.length);
    },
    async subscribe({ commit, dispatch, state }) {
      if (state.list != null) {
        return;
      }
      if (!state.subscribed) {
        dispatch('loadAll');
      }
      await new Promise(resolve => commit('addObserver', resolve));
    },
    loadAll({ commit, state }) {
      commit('subscribe');
      database.ref('games')
        .on('value', (snapshot) => {
          commit('updateAll', snapshot.val());
          state.observers.forEach(resolve => resolve());
          commit('clearObservers');
        });
    },
    async setTextsForGame({ rootState }, { gameHash, roundNr, currentTextModels }) {
      const { uid } = rootState.auth;
      const texts = [];
      Object.keys(currentTextModels).forEach((key) => {
        const [phraseIndex, textIndex] = key.split('-');
        if (texts[phraseIndex] == null) {
          texts[phraseIndex] = [];
        }
        texts[phraseIndex][textIndex] = currentTextModels[key];
      });
      await Promise.all(texts.map(async (text, index) => {
        const ref = `games/${gameHash}/rounds/${roundNr}/phrases/${index}/playerInputs/${uid}/text`;
        await database.ref(ref).set(text);
      }));
    },
    async setGuessesForGame({ rootState }, { gameHash, roundNr, guesses }) {
      const { uid } = rootState.auth;
      await Promise.all(guesses.map(async (guess, index) => {
        const ref = `games/${gameHash}/rounds/${roundNr}/phrases/${index}/playerInputs/${uid}/guess`;
        await database.ref(ref).set(guess);
      }));
    },
    async nextRound(arg1, { game, nextRound }) {
      const round = game.rounds.length - 1;
      let ref = `games/${game.hash}/rounds/${round}/finished`;
      await database.ref(ref).set(1);
      if (nextRound == null) {
        return;
      }
      ref = `games/${game.hash}/rounds/${game.rounds.length}`;
      await database.ref(ref).set(nextRound);
    },
    async abort(arg1, { game }) {
      await database.ref(`games/${game.hash}/aborted`).set(1);
    },
    async nextGamePrepare(arg1, { game, nextGame }) {
      const ref = `games/${game.hash}/next`;
      await database.ref(ref).set(nextGame);
    },
    async nextGameJoin({ rootState }, { game }) {
      const ref = `games/${game.hash}/next/players`;
      const newPlayers = [...game.next.players, rootState.auth.uid];
      await database.ref(ref).set(newPlayers);
    },
    async nextGameCreate({ dispatch }, game) {
      await dispatch('create', game);
      const ref = `games/${game.previous}/next/hash`;
      await database.ref(ref).set(game.hash);
    },
  },
};
